import { RoleManagementUIModel } from "src/store/models/ui/roleManagement/roleManagement";
import { RoleManagementTableUIModel } from "src/store/models/ui/roleManagement/roleManagementTable";

export const encooRoleManagementUIModels = {
  RoleManagement: RoleManagementUIModel,
  RoleManagementTable: RoleManagementTableUIModel,
};
